<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 15L12 11L7 15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>